import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import PostLogin from "./post-login";
import PreLogin from "./pre-login";
import { observable } from "mobx";
import { observer } from "mobx-react";

@observer
class App extends Component {
  @observable hasToken = false;
  @observable statusHired = false;

  constructor() {
    super();

    this.state = {
      isLoggedIn: false
    };
  }

  getToken = () => {
    if (JSON.parse(localStorage.getItem("userData"))) {
      return JSON.parse(localStorage.getItem("userData")).token;
    }
  };

  getStatus = () => {
    // console.log(JSON.parse(localStorage.getItem("userData")));
    if (JSON.parse(localStorage.getItem("userData"))) {
      return JSON.parse(localStorage.getItem("userData")).data.status;
    }
  };

  componentDidMount() {
    if (this.getToken() && this.getToken().length) {
      // this.setState({ hasToken: true })
      this.hasToken = true;
    }
    if (this.getStatus() && this.getStatus() === "HIRED") {
      this.statusHired = true;
    }
  }

  componentWillReceiveProps() {
    if (this.getToken() && this.getToken().length) {
      // this.setState({ hasToken: true })
      this.hasToken = true;
    }
    if (this.getStatus() && this.getStatus() === "HIRED") {
      this.statusHired = true;
    }
  }

  render() {
    console.log(this.hasToken, this.statusHired);
    return (
      <Switch>
        {/* {this.hasToken && this.statusHired ? (
          <Route path="/" component={PostLogin} />
        ) : (
          <Route path="/" component={PreLogin} />
        )} */}
        <Route path="/" component={PreLogin} />
      </Switch>
    );
  }
}

export default App;
